import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar.js';
import { Topbar } from './Topbar.js';
import './app-shell.css';

interface AppShellProps {
  projectName: string;
  userName: string;
  userRole: string;
  /** Locks the page to the viewport: the window never scrolls, regions do. */
  fullHeight?: boolean;
  onSeeded?: () => void;
  children: ReactNode;
}

export function AppShell({ projectName, userName, userRole, fullHeight, onSeeded, children }: AppShellProps) {
  return (
    <div className={`shell${fullHeight ? ' shell--locked' : ''}`}>
      <Sidebar projectName={projectName} />
      <div className="shell__main">
        <Topbar userName={userName} userRole={userRole} onSeeded={onSeeded} />
        <main className="shell__content">{children}</main>
      </div>
    </div>
  );
}
